import AVdxbButton from './index.vue';

AVdxbButton.install = app => {
  app.component(AVdxbButton.name, AVdxbButton);
};

export default AVdxbButton;
